<template>
  <div>
    <b-card>
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">
            Historial de Pagos
          </h4>
          <div class="ml-auto">
            <b-button
              variant="primary"
              size="sm"
              class="ml-4"
              @click="query"
            >
              <feather-icon
                icon="RefreshCwIcon"
                size="14"
                class="mr-50"
              />
              Actualizar
            </b-button>
          </div>
        </div>
      </template>

      <b-table
        responsive
        :fields="fields"
        :items="items"
        :busy="isBusy"
        show-empty
        empty-text="No hay pagos registrados"
        head-variant="dark"
        striped
        hover
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner variant="primary" />
          </div>
        </template>

        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template #cell(status)="data">
          <b-badge
            pill
            :variant="
              data.item.status
                ? data.item.status.class
                : 'secondary'
            "
          >
            {{ data.item.status ? data.item.status.name : '-' }}
          </b-badge>
        </template>

        <template #cell(fechaserver)="data">
          {{ formatDate(data.value) }}
        </template>

        <template #cell(total)="data">
          <strong>{{ data.value }}</strong>
        </template>

        <template #cell(detail)="data">
          <b-button
            variant="info"
            size="sm"
            pill
            @click="showDetail(data.item.idpayment)"
          >
            <feather-icon
              icon="EyeIcon"
              size="14"
            />
          </b-button>
        </template>

        <template #cell(print)="data">
          <b-button
            variant="primary"
            size="sm"
            pill
            @click="print(data.item.collection_id)"
          >
            <feather-icon
              icon="PrinterIcon"
              size="14"
            />
          </b-button>
        </template>

        <template #custom-foot>
          <tr class="bg-light">
            <td
              colspan="5"
              class="text-right"
            >
              <strong>TOTAL:</strong>
            </td>
            <td class="text-right">
              <strong class="text-primary">{{ total }}</strong>
            </td>
            <td colspan="5" />
          </tr>
        </template>
      </b-table>
    </b-card>

    <b-modal
      ref="paymentDetailModal"
      title="Detalles del Pago"
      size="lg"
      centered
      hide-footer
    >
      <account-setting-payment-detail
        v-if="selectedPaymentId"
        :idpayment="selectedPaymentId"
      />
    </b-modal>
  </div>
</template>

<script>
import { BBadge, BButton, BCard, BSpinner, BTable } from 'bootstrap-vue'
import AccountSettingPaymentDetail from '@/views/pages/account-setting/AccountSettingPaymentDetail.vue'

export default {
    components: {
        BCard,
        BTable,
        BButton,
        BBadge,
        BSpinner,
        AccountSettingPaymentDetail,
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem('userData')),
            isBusy: false,
            items: [],
            selectedPaymentId: null,
            fields: [
                { key: 'index', label: '#' },
                { key: 'codigo', label: 'Código' },
                { key: 'direccion', label: 'Dirección' },
                { key: 'fechaserver', label: 'Fecha' },
                { key: 'reference', label: 'Referencia' },
                { key: 'total', label: 'Total', class: 'text-right' },
                { key: 'status', label: 'Estado' },
                { key: 'message', label: 'Mensaje' },
                { key: 'authorization', label: 'Autorización' },
                { key: 'detail', label: 'Detalle' },
                { key: 'print', label: 'Imprimir' },
            ],
        }
    },
    computed: {
        total() {
            return this.items
                .reduce((sum, item) => sum + (parseFloat(item.total) || 0), 0)
                .toFixed(2)
        },
    },
    created() {
        this.query()
    },
    methods: {
        query() {
            this.isBusy = true
            this.$http
                .get('/payment', { params: { idusuario: this.userData.id } })
                .then((res) => {
                    this.items = res.data.data || []
                })
                .catch(() => {})
                .finally(() => {
                    this.isBusy = false
                })
        },

        formatDate(value) {
            if (!value) return ''
            const d = new Date(value)
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
                2,
                '0'
            )}-${String(d.getDate()).padStart(2, '0')} ${String(
                d.getHours()
            ).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
        },

        showDetail(id) {
            this.selectedPaymentId = id
            this.$refs.paymentDetailModal.show()
        },

        print(id) {
            const url = `${process.env.VUE_APP_API_URL}/payment-print?idpayment[]=${id}`
            window.open(url, '_blank')
        },
    },
}
</script>
